import BaseComponent from 'foundation/base-component';

export default class ExploreOtherSitesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this._isExpanded =
            this.element.classList.contains('is-expanded') || false;

        this.onClickTrigger = this.onClickTrigger.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onOuterClick = this.onOuterClick.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['trigger', 'list', 'item'];
    }

    init() {
        this.refs.trigger.setAttribute(
            'aria-expanded',
            this._isExpanded.toString()
        );

        this.addListener(this.refs.trigger, 'click', this.onClickTrigger);
        this.addListener(document, 'keydown', this.onKeydown);
        this.addListener(document, 'click', this.onOuterClick);
        this.addListener(document, 'touchstart', this.onOuterClick);
    }

    onClickTrigger(event) {
        event.preventDefault();

        if (this._isExpanded) {
            this.collapse();
        } else {
            this.expand();
        }
    }

    onKeydown(event) {
        if (event.keyCode === 27 && this._isExpanded) {
            this.collapse();
            this.refs.trigger.focus();
        }
    }

    onOuterClick(event) {
        if (this._isExpanded && !this.element.contains(event.target)) {
            this.collapse();
        }
    }

    setItemAnimation(animate) {
        if (Array.isArray(this.refs.item)) {
            this.refs.item.forEach((item) => {
                if (animate) {
                    item.classList.add('is-animation');
                } else {
                    item.classList.remove('is-animation');
                }
            });
        } else if (this.refs.item) {
            if (animate) {
                this.refs.item.classList.add('is-animation');
            } else {
                this.refs.item.classList.remove('is-animation');
            }
        }
    }

    expand() {
        this._isExpanded = true;
        this.element.classList.add('is-expanded');
        this.refs.trigger.setAttribute('aria-expanded', 'true');

        if (Array.isArray(this.refs.iconWrapper)) {
            this.refs.iconWrapper.forEach((icon) => {
                icon.classList.add('is-animation');
            });
        }

        setTimeout(() => {
            this.setItemAnimation(true);
        }, 50);
    }

    collapse() {
        this._isExpanded = false;
        this.element.classList.remove('is-expanded');
        this.refs.trigger.setAttribute('aria-expanded', 'false');

        if (Array.isArray(this.refs.iconWrapper)) {
            this.refs.iconWrapper.forEach((icon) => {
                icon.classList.remove('is-animation');
            });
        }

        this.setItemAnimation(false);
    }
}
